<script>
import RedactorControl from '../RedactorControl.vue';

export default {
    components: {
        RedactorControl
    },

    props: {
        defaultSkillAssessmentSpecs: {
            type: Array,
            required: true
        },
        classmarkerAssessments: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            skillAssessmentSpecs: [...this.defaultSkillAssessmentSpecs]
        }
    },

    methods: {
        addSkillAssessmentSpec() {
            this.skillAssessmentSpecs.push({
                id: null,
                title: '',
                method: '',
                benchmark: '',
                instructions: '',
            })
        },
        removeSkillAssessmentSpec(index) {
            this.skillAssessmentSpecs.splice(index, 1)
        }
    }
}
</script>

<template>
    <div class="skill-assessment-specs">
        <div v-if="skillAssessmentSpecs.length > 0" class="grid-x grid-padding-x mb-2">
            <div class="cell pl-10 ml-6 pr-0 small-2 large-2">
                <label>Assessment Type:</label>
            </div>

            <div class="cell pl-4 ml-1 pr-0 small-2 large-2">
                <label>Method:</label>
            </div>

            <div class="cell pl-4 ml-1 pr-0 small-2 large-2">
                <label>Benchmark:</label>
            </div>
            <div class="cell pl-4 ml-1 pr-0 small-1 large-1">
                <label></label>
            </div>
            <div class="cell pl-4 ml-1 pr-0 small-2 large-2">
                <label>Instructions:</label>
            </div>
        </div>

        <div v-for="(skillAssessmentSpec, i) in skillAssessmentSpecs" class="grid-x grid-padding-x mb-2">
            <input v-if="skillAssessmentSpec.id" :name="`skill_assessment_specs[${i}][id]`" type="hidden" required v-model="skillAssessmentSpec.id" />

            <div class="cell pl-10 pr-0 ml-6 small-2 large-2">
                <input :disabled="disabled" :name="`skill_assessment_specs[${i}][title]`" type="text" required v-model="skillAssessmentSpec.title" />
            </div>

            <div class="cell pl-4 pr-0 ml-1 small-2 large-2">
                <select :disabled="disabled" :name="`skill_assessment_specs[${i}][method]`" required v-model="skillAssessmentSpec.method">
                    <option value="classmarker">Classmarker</option>
                    <option value="lms">LMS</option>
                    <option value="on_prem">On Premesis</option>
                    <option value="other">Other</option>
                </select>
            </div>

            <div class="cell pl-4 pr-0 ml-1 small-2 large-2">

                <template v-if="skillAssessmentSpec.method === 'classmarker'">
                    <select :disabled="disabled" :name="`skill_assessment_specs[${i}][classmarker_assessment_id]`" required v-model="skillAssessmentSpec.classmarker_assessment_id">
                        <option v-for="classmarkerAssessment in classmarkerAssessments" :value="classmarkerAssessment.id">
                            {{ classmarkerAssessment.title }}
                        </option>
                    </select>

                    <input :name="`skill_assessment_specs[${i}][benchmark]`" value="" type="hidden" />
                </template>
                <template v-else>
                    <textarea :disabled="disabled" :name="`skill_assessment_specs[${i}][benchmark]`" required v-model="skillAssessmentSpec.benchmark"></textarea>

                    <input :name="`skill_assessment_specs[${i}][classmarker_assessment_id]`" value="" type="hidden" />
                </template>
            </div>
            <div class="cell pl-4 ml-1 pr-0 pl-0 w-auto">
                <div v-if="!disabled" @click="() => removeSkillAssessmentSpec(i)" class="remove-button"><i class="fas fa-minus-circle"></i></div>
            </div>
            <div class="cell pl-4 pr-0 ml-1 auto">
                <textarea v-if="disabled" :disabled="disabled" :name="`skill_assessment_specs[${i}][instructions]`" placeholder="Enter instructions..." type="text" v-model="skillAssessmentSpec.instructions" rows="4"></textarea>
                <RedactorControl v-if="!disabled"
                    :name="`skill_assessment_specs[${i}][instructions]`"
                    :value="(skillAssessmentSpec) ? skillAssessmentSpec.instructions : ''"
                    rows="5"
                />
            </div>
        </div>

        <div v-if="!disabled" @click="addSkillAssessmentSpec" class="add-button"><i class="fas fa-plus-circle"></i></div>

        <input v-if="skillAssessmentSpecs.length === 0" name="skill_assessment_specs" value="" type="hidden" />
    </div>
</template>